import useMount from "hooks/useMount";

export default function ClientOnly({
  children,
  fallback = <></>,
}: {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  const mounted = useMount();

  if (!mounted) {
    return fallback;
  }

  return children;
}
